import { UilPadlock } from '@iconscout/react-unicons'
import { Button, Message } from 'components'
import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { selectCurrentUser } from 'services/slices/auth'
import { useTranslation } from 'utils/useTranslation'

export const NotAuthenticated: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation('pages.common.fallback.not_auth')
  const navigate = useNavigate()
  const user = useSelector(selectCurrentUser)
  const isCustomerPortalUser = user?.customer_portal_credentials != null
  return (
    <Message
      icon={{ icon: UilPadlock, color: 'darkblue600' }}
      heading={t('permission_text')}
      subtitle={t('contact_text')}
      primaryButton={
        <Button
          variant="text"
          onClick={() =>
            navigate(
              isCustomerPortalUser
                ? `/engagement/customer_portal/${user.customer_portal_credentials?.entity_id}`
                : '/',
            )
          }
        >
          {t('go_back')}
        </Button>
      }
      fullPage
    />
  )
}
